<template>
    <Link
        v-if="routeUrl"
        :href="routeUrl"
        class="link"
    >
        <div
            tabindex="-1"
            class="item"
            :class="active ? 'active' : ''"
            @click="clickHandler"
        >
            {{ label }}
        </div>
    </Link>
    <div
        v-else
        class="button"
    >
        <div
            tabindex="-1"
            class="item"
            :class="active ? 'active' : ''"
            @click="clickHandler"
        >
            {{ label }}
        </div>
    </div>
</template>

<script>
export default {
    name: 'DTabItem',
    props: {
        label: {
            type: String,
            required: true
        },
        active: {
            type: Boolean,
            required: false,
            default () {
                return false
            }
        },
        routeUrl: {
            type: String,
            required: false,
            default () {
                return ''
            }
        }
    },
    emits: ['click'],
    methods: {
        clickHandler () {
            this.$emit('click')
        }
    }
}
</script>

<style lang="scss" scoped>
.item {
    display: block;
    padding: 15px;
    color: #000;
    font-size: 16px;
    text-decoration: none;
    border-radius: 5px;
    border: 1px solid transparent;
    cursor: pointer;

    &:hover {
        background: rgba(0,0,0,0.07);
        cursor: pointer;
    }
    &.active {
        background: var(--colorAppSurface);
        border-color: var(--colorAppBorder);
    }
}

.link {
    &:hover {
        color: #000;
        text-decoration: none;
    }
}
</style>
